/**
 *通用参数说明
 * @param type Number 1,2 默认调用，手动调用
 * @param options Object getCityPosition，getCityIp 经纬度获取城市信息的接口，ip获取城市信息的接口
 */
const position =new class{

  //微信定位的方法
      // //精准定位
      // getRelocation:function(type){
      //     if(this.isWeiXin()){
      //         this.getConfig(type)
      //     }else{
      //         this.positionFun.getCurrentPosition(type);
      //     }
      // },
      //判断当前环境是否是微信环境
      isWeiXin() {
          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
              return true;
          } else {
              return false;
          }
      }
      /**
       * 通过config接口注入权限验证配置
       * 参数见通用参数说明
       */
      getConfig(options){
          var self = this
          var dateStram = (new Date()).getTime();
          var url="/bargain/weiXinAuth/weChat_shareConf";
          $.ajax({
              type:"post",
              url:url+"?timeStram="+dateStram,
              data:{"url":window.location.href},
              async:false,
              'beforeSend': function (XMLHttpRequest,settings) {},
              success:function(data){
                  if(data.result){
                      wx.config({
                          debug: false,
                          appId: data.result.appId, // 必填，公众号的唯一标识
                          timestamp: data.result.timestamp, // 必填，生成签名的时间戳
                          nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
                          signature: data.result.signature,// 必填，签名，见附录1
                          jsApiList: ["getLocation"]
                      });
                  }else if(data.response){
                      wx.config({
                          debug: false,
                          appId: data.response.result.appId, // 必填，公众号的唯一标识
                          timestamp: data.response.result.timestamp, // 必填，生成签名的时间戳
                          nonceStr: data.response.result.nonceStr, // 必填，生成签名的随机串
                          signature: data.response.result.signature,// 必填，签名，见附录1
                          jsApiList: ["getLocation"]
                          //jsApiList: ["onMenuShareTimeline","onMenuShareAppMessage"]
                      });
                  }else{
                      return;
                  };
                  wx.ready(function(){
                      self.getWXLocation(options);
                  })
              },
              error:function(jqXHR, textStatus, errorThrown) {
                  console.log("errorConfig");
              }
          })
      }
      /**
       * 微信获取经纬度
       * 参数见通用参数说明
       */
      getWXLocation(options){
          wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                  var obj={};
                  obj.longitude = res.longitude;
                  obj.latitude = res.latitude;

                  // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                  // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                  // var speed = res.speed; // 速度，以米/每秒计
                  // var accuracy = res.accuracy; // 位置精度
                  options.getCityPosition(obj,options.status);
              },
              fail:function(res){
                  options.getCityIp(options.status);
              },
              cancel: function (res) {
                  options.getCityIp(options.status);
              }
          });
    }
    /**
     * 定位失败的函数
     * @param e Object code,message code码，信息
     * @param options Object getCityPosition，getCityIp 经纬度获取城市信息的接口，ip获取城市信息的接口
     */
    getPositionError(e,options){
        // var self = this;
        var msg = e.code;
        var dd = e.message;
        console.log(msg)
        console.log(dd)
        options.getCityIp(options.status);
    }
    /**
     * js获取经纬度
     * 参数见通用参数说明
     */
    getCurrentPosition(options){
        // var self = this;
        if(navigator.geolocation) {
            //创建定时器
            let timer=setTimeout(function(){
                this.positionFun.getPositionError({code:"PERMISSION_DENIED",msg:"不允许定位"})
            },10000)
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    //清除定时器
                    clearTimeout(timer);
                    var obj={};
                    obj.longitude = position.coords.longitude;
                    obj.latitude = position.coords.latitude;
                    console.log(obj.longitude,obj.latitude,'jingwei')
                    options.getCityPosition(obj,options.status)
                },
                function (e) {
                    //清除定时器
                    clearTimeout(timer);
                    var msg = e.code;
                    var dd = e.message;
                    options.getCityIp(options.status);
                },{timeout:5000}
            )
        }else{
            options.getCityIp(options.status);
        }
    }

}
export {position}









// WEBPACK FOOTER //
// ./static/js/lib/positionFn.js